<!--
     <Actions
       size='small'
       :unit="QUnit"
       @update="update(filters)"
       @update-qunit="update_qunit(new_qunit)"
       :action_list="['ActionTransitions', 'ActionDownloadEvidence']"
     />
-->

<template>
  <div class="actions-cont">
    <component
      v-for="(act, index) in whitelist"
      :key="act"
      :is="act"
      :size="size"
      :unit="unit"
      :loading="loading[index]"
      color="ctas darken-2"
      @transition="(trans) => action_transition(act, trans)"
      @update="update_qunit"
      @refresh="refresh_qunit"
      @clicked="clicked"
      @loading_start="loading_add(act)"
      @loading_stop="loading_pop(act)"
    />

    <!-- Modal dialog -->
    <GenericQUnitTransition
      ref="genericTransition"
      :centro="unit._protected.centro"
      @update="update_after_transition"
      @cancel="loading_reset"
    />
  </div>
</template>


<style>
 .actions-cont {
   display: flex;
   gap: .2em;
   align-items: center;
   justify-content: space;
 }
</style>


<script>
 import QUnit from '@/qunit/QUnit';
 import QUnitAPI from '@/api/QUnit';
 import GenericQUnitTransition from '@/components/explorer/GenericQUnitTransition';
 import ActionTransitions from './ActionTransitions';
 import ActionDownloadEvidence from './ActionDownloadEvidence';
 import ActionDownloadCurrent from './ActionDownloadCurrent';
 import ActionShowContacts from './ActionShowContacts';
 import ActionViewReports from './ActionViewReports';
 import ActionAllowedContents from './ActionAllowedContents';
 import ActionNavigate from './ActionNavigateTo';
import ActionViewQUnit from './ActionViewQUnit';
import ActionDownloadEvidenceOptions from './ActionDownloadEvidenceOptions';


 export default {
   name: 'Actions',

   components: {
     GenericQUnitTransition,
     ActionTransitions,
     ActionShowContacts,
     ActionDownloadEvidence,
     ActionDownloadCurrent,
     ActionViewReports,
     ActionAllowedContents,
     ActionNavigate,
     ActionViewQUnit,
     ActionDownloadEvidenceOptions,
   },

   props: {
     unit: {required: true},
     size: {default: 'small'},
     action_list: {default: () => ([])},
   },

   data: () => ({
     expanded: -1,
     loading: [],

     actions_default_list: [
       'ActionTransitions',
       'ActionShowContacts',
       'ActionDownloadEvidence',
       'ActionDownloadEvidenceOptions',
       'ActionViewReports',
       'ActionAllowedContents',
     ],
   }),

   mounted() {
     this.loading_reset();
   },

   computed: {
     whitelist() {
       if (this.action_list === undefined || this.action_list.length < 1) {
         if (this.unit.actions !== undefined && this.unit.actions.length > 0) {
           return this.unit.actions;
         }
         return this.actions_default_list;
       }
       return this.action_list;
     },
   },

   methods: {
     loading_add(item) {
       this.$set(this.loading, this.whitelist.indexOf(item), true); // Reactive
     },

     loading_pop(item) {
       this.$set(this.loading, this.whitelist.indexOf(item), false); // Reactive
     },

     loading_reset(length) {
       this.loading = Array(length || this.whitelist.length).fill(false);
     },

     action_transition(component, transition) {
       this.loading_add(component);
       this.$refs.genericTransition.launch_transition(this.unit, transition);
     },

     async update_after_transition(data) {
       let new_qunit = new QUnit(data);
       if (this.unit.uid != new_qunit.uid) {
         const updated_data = await QUnitAPI.getQUnit(this.unit._protected.centro, this.unit.uid);
         if (!new_qunit) {
           this.loading_reset();
           throw `Something odd happened. Can't read QUnit ${this.unit.uid}`;
         }
         new_qunit = new QUnit(updated_data);
       }

       this.loading_reset();
       //  this.$emit('update-qunit', new_qunit);
      this.update_qunit(new_qunit)
     },

     update_qunit(new_qunit) {
      this.$emit('update-qunit', new_qunit);
     },

     refresh_qunit() {
      this.$emit('refresh');
     },

     clicked() {
      this.$emit('clicked');
     },
   },

   watch: {
     whitelist(val) {
       this.loading_reset(val.length);
     },
   },
 }
</script>
